/**
 * @module searchString
 * @file searchString.js
 * @description This file contains a function to search for a string in an
 *              object. It checks if the needle is a string within the haystack
 *              object. It returns true if found, false otherwise.
 * @returns {boolean} - Returns true if the needle is found in the haystack,
 *              false otherwise.
 * @param {string} needle - The string to search for.
 * @param {object} haystack - The object to search within. It can be a string,
 *              array, or a plain object.
 * @since 2025.04.14
 * @version 2025.04.14
 */

export function searchString(needle = "", haystack = {}) {
    if (typeof needle !== "string") {
        return false;
    }
    if (typeof haystack === "string") {
        return haystack.includes(needle);
    }
    if (typeof haystack !== "object" || haystack === null) {
        return false;
    }
    if (Array.isArray(haystack)) {
        for (const element of haystack) {
            if (typeof element === "string" && element.includes(needle)) {
                return true;
            }
            if (
                typeof element === "object" &&
                element !== null &&
                searchString(needle, element)
            ) {
                return true;
            }
        }
    } else {
        for (const key in haystack) {
            if (Object.prototype.hasOwnProperty.call(haystack, key)) {
                const value = haystack[key];
                if (typeof value === "string" && value.includes(needle)) {
                    return true;
                }
                if (
                    typeof value === "object" &&
                    value !== null &&
                    searchString(needle, value)
                ) {
                    return true;
                }
            }
        }
    }

    return false;
}
